"use client"

import styled from "@emotion/styled"
import { Drawer } from "@mui/material"
import { useTranslations } from "next-intl"
import { Dispatch, SetStateAction } from "react"
import { useIsDesktop } from "ui"
import ContactForm, { FormProjectProps } from "../../Form"
import PaymentForm, { PaymentFormProps } from "./PaymentForm"

const StyledDrawer = styled(Drawer)`
  box-shadow: none;
  border: none;
  ::before {
    content: none;
  }
`

type Props = {
  drawerOpen: boolean
  setDrawerOpen: Dispatch<SetStateAction<boolean>>
  formProps: FormProjectProps | PaymentFormProps
  paymentForm?: boolean
}

const DrawerContactForm = ({ drawerOpen, setDrawerOpen, formProps, paymentForm }: Props) => {
  const isDesktop = useIsDesktop()
  const t = useTranslations("ProjectsPage")
  return (
    <StyledDrawer
      anchor={isDesktop ? "left" : "bottom"}
      open={drawerOpen}
      transitionDuration={800}
      onClose={() => setDrawerOpen(false)}
      sx={{ zIndex: 999999 }}
      SlideProps={{
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: 658 },
          height: { xs: "90%", md: "100%" },
          borderRadius: {
            xs: "16px 16px 0 0",
            md: 0,
          },
        },
      }}
    >
      {paymentForm ? (
        <PaymentForm
          {...(formProps as PaymentFormProps)}
          advancedPaymentTitle={t("advancePayment")}
        />
      ) : (
        <ContactForm {...(formProps as FormProjectProps)} title={t("leaveDetails")} />
      )}
    </StyledDrawer>
  )
}
export default DrawerContactForm
